var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.091 22H1.91C.44 22-.477 20.417.261 19.148L10.85.947c.736-1.263 2.563-1.263 3.298 0l10.591 18.2c.738 1.27-.18 2.853-1.649 2.853zm-.322-2.45L12.828 2.467a.385.385 0 00-.66.015L2.226 19.56c-.098.211.02.538.345.538h19.857c.318 0 .452-.324.341-.548zm-9.338-5.796c-.064.381-.478.653-.931.653-.454 0-.868-.272-.932-.653l-.563-4.596a2.88 2.88 0 01-.042-.49v-.053c0-.847.688-1.533 1.536-1.533.848 0 1.535.686 1.535 1.533v.052s.018.14-.041.49l-.562 4.597zm-.932 1.998a1.428 1.428 0 110 2.855 1.428 1.428 0 110-2.855z",
    fill: "currentColor"
  })));
}

export default SvgWarning;